import React from 'react';
import { DocPageLayout } from '../components/DocPageLayout';
import { InfoBox } from '../components/InfoBox';
import { StepList } from '../components/StepList';
import { CodeBlock } from '../components/CodeBlock';
export function GettingStartedPage() {
  const steps = [{
    title: 'Create a test account',
    content: <>
          <p data-id="element-1607">
            Before you can start integrating, you need a test merchant account.
            This allows you to simulate transactions without moving real money.
          </p>
          <InfoBox type="tip" title="Test Credentials" data-id="element-1608">
            Your test credentials (Merchant ID and API Password) will be emailed
            to you immediately after registration. Keep these secure.
          </InfoBox>
        </>
  }, {
    title: 'Choose your integration method',
    content: <p data-id="element-1609">
          Review the <strong data-id="element-1610">Integration Types</strong> in the sidebar to
          determine which solution best fits your business needs and PCI
          compliance requirements. We recommend{' '}
          <strong data-id="element-1611">&lt;&lt;checkout&gt;&gt;</strong> for the easiest setup.
        </p>
  }, {
    title: 'Make your first API request',
    content: <>
          <p data-id="element-1612">
            Use your test credentials to authenticate and make a simple API
            request to verify your connection.
          </p>
          <CodeBlock language="cURL" title="Authentication Test" code={`curl https://test-gateway.mastercard.com/api/rest/version/72/merchant/{merchantId}/session \\
  -u "merchant.{merchantId}:{apiPassword}" \\
  -X POST \\
  -H "Content-Type: application/json" \\
  -d '{}'`} data-id="element-1613" />
        </>
  }];
  return <DocPageLayout title="Getting Started" description="Follow these steps to begin integrating the Payment Gateway into your application." data-id="element-1614">
      <p className="text-gray-700 mb-6" data-id="element-1615">
        Welcome to the Payment Gateway documentation. This guide will walk you
        through the essential steps to get your integration up and running
        quickly and securely.
      </p>

      <InfoBox type="warning" title="API Versioning" data-id="element-1616">
        The examples in this documentation use API version 72. Always ensure you
        are using the latest supported version for new integrations.
      </InfoBox>

      <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-6" data-id="element-1617">
        Integration Steps
      </h2>
      <StepList steps={steps} data-id="element-1618" />

      <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-4" data-id="element-1619">
        Next Steps
      </h2>
      <p className="text-gray-700" data-id="element-1620">
        Once you have successfully authenticated, you are ready to start
        building your payment flow. Navigate to the specific integration type
        you chose to see detailed implementation instructions.
      </p>
    </DocPageLayout>;
}